module.exports = __webpack_public_path__ + "img/back_01.eea21906.png";